export default "__VITE_ASSET__DVP8E9oH__"